import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useContext, useRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { dsI18n, getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { Icon, CancelSVGpath } from '@skatteetaten/ds-icons';
import { g as getChipDefaultSize } from '../defaults.esm.js';
import { ChipsContext } from '../ChipsContext/index.esm.js';
import './styles.css';


var styles = {
    "removableChip": "ChipsRemovable-module_removableChip__-ecmx",
    "removableChip_small": "ChipsRemovable-module_removableChip_small__NJvSN",
    "icon": "ChipsRemovable-module_icon__2viO9"
};

const ChipsRemovable = /*#__PURE__*/ forwardRef(({ id, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, size = getChipDefaultSize(), disabled, onClose, children }, ref)=>{
    const { t } = useTranslation('ds_collections', {
        i18n: dsI18n
    });
    const { updateFocus } = useContext(ChipsContext);
    const chipRef = useRef(null);
    useImperativeHandle(ref, ()=>chipRef.current);
    const concatenatedClassName = `${styles.removableChip} ${size === 'small' ? styles.removableChip_small : ''} ${className}`.trim();
    const handleOnClose = ()=>{
        if (chipRef.current) {
            updateFocus?.(chipRef.current);
        }
        onClose?.();
    };
    return /*#__PURE__*/ jsxs("button", {
        ref: chipRef,
        type: 'button',
        disabled: disabled,
        id: id,
        className: concatenatedClassName,
        lang: lang,
        "data-testid": dataTestId,
        onClick: handleOnClose,
        children: [
            children,
            /*#__PURE__*/ jsx(Icon, {
                className: styles.icon,
                svgPath: CancelSVGpath,
                size: 'small',
                title: t('chips.RemoveFilter')
            })
        ]
    });
});
ChipsRemovable.displayName = 'ChipsRemovable';

export { ChipsRemovable };
